// extracted by mini-css-extract-plugin
module.exports = {"link":"MailLinkStyles_link__3Ig2_"};